<template>
<div class="chapter">
<div class="inner_page">
<p class="ser2"><img alt="AtomicRanchBook_0003_001" id="d14e42" src="images/AtomicRanchBook_0003_001.jpg"/></p><p class="bkt" id="d7e263"><b>atomic RANCH</b> </p>
<p class="pub" id="d7e313"><b>DESIGN IDEAS FOR STYLISH RANCH HOMES</b> </p>
<p class="au" id="d7e363"><b>Michelle Gringeri-Brown </b><br/><b>Photographs by Jim Brown </b></p>
<p class="ser1"><img alt="AtomicRanchBook_0003_002" id="d14e53" src="images/AtomicRanchBook_0003_002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_c3_r1.vue?7026ce1d